import React from "react";
import { useSelector } from "react-redux";

const CoinMiningInstruction = () => {
  const { brokerBasicInfo } = useSelector((state) => state);
  const path = window.location.pathname;
  const coinName = path.split("/")[1].split("-")[0];
  return (
    <div className="container" style={{ color: "gray" }}>
      <div className="row row-flex">
        <div className="col-md-12">
          <div className="mt-5">
            <div className="terms-use-wrap">
              <div className="common-bg-color-opacity p-3 mb-4 text-gray-900">
                {coinName === "btc" && (
                  <div className="common-bg-color-opacity border-bt p-4">
                    <h1 style={{ textAlign: "center" }}>
                      <span style={{ fontWeight: 400 }}>
                        How to mine Bitcoin in {brokerBasicInfo?.exchange}?
                      </span>
                    </h1>

                    <h2>
                      <span style={{ fontWeight: 400 }}>General Overview:</span>
                    </h2>

                    <p>
                      <span style={{ fontWeight: 400 }}>
                        Bitcoin was the first cryptocurrency. It allows users to
                        send and receive digital money called bitcoins (with a
                        lowercase b, or BTC). What makes bitcoin highly
                        appealing is its inherent resistance to censorship, the
                        impossibility of double-spending funds, and the ability
                        to conduct transactions anytime and anywhere.
                      </span>
                    </p>

                    <p>
                      <span style={{ fontWeight: 400 }}>
                        Bitcoin uses a SHA256 encryption algorithm and has a
                        total of 21 million blocks. Typically, one block is
                        generated every 10 minutes and the reward is cut in half
                        every 210,000 blocks. Currently, most mining pools
                        distribute transaction fees to miners in addition to
                        block rewards.
                      </span>
                    </p>

                    <h2>
                      <span style={{ fontWeight: 400 }}>Basic Information</span>
                    </h2>

                    <table>
                      <tbody>
                        <tr>
                          <td>
                            <h3>
                              <span style={{ fontWeight: 400 }}>Items</span>
                            </h3>
                          </td>
                          <td>
                            <h3>
                              <span style={{ fontWeight: 400 }}>Details</span>
                            </h3>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span style={{ fontWeight: 400 }}>Website</span>
                          </td>
                          <td>
                            <a href="https://bitcoin.org/">
                              <span style={{ fontWeight: 400 }}>
                                Bitcoin.org
                              </span>
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span style={{ fontWeight: 400 }}>
                              Block explorer
                            </span>
                          </td>
                          <td>
                            <a href="https://www.blockchain.com/explorer">
                              <span style={{ fontWeight: 400 }}>
                                Blockchain.com
                              </span>
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span style={{ fontWeight: 400 }}>
                              Total supply
                            </span>
                          </td>
                          <td>
                            <span style={{ fontWeight: 400 }}>
                              21 million BTC
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span style={{ fontWeight: 400 }}>Algorithm</span>
                          </td>
                          <td>
                            <span style={{ fontWeight: 400 }}>SHA256d</span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span style={{ fontWeight: 400 }}>Consensus</span>
                          </td>
                          <td>
                            <span style={{ fontWeight: 400 }}>
                              Proof of Work
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span style={{ fontWeight: 400 }}>Block time</span>
                          </td>
                          <td>
                            <span style={{ fontWeight: 400 }}>10 minutes</span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span style={{ fontWeight: 400 }}>
                              Current block rewards
                            </span>
                          </td>
                          <td>
                            <span style={{ fontWeight: 400 }}>6.25 BTC</span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span style={{ fontWeight: 400 }}>
                              Mining device
                            </span>
                          </td>
                          <td>
                            <a href="https://www.f2pool.com/miners?currency_code=btc">
                              <b>ASIC miner</b>
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <h2>
                      <span style={{ fontWeight: 400 }}>
                        Hardware Requirement:-
                      </span>
                    </h2>

                    <ul>
                      <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                          Bitcoin can be efficiently mined with SHA256d ASIC
                          mining machines
                        </span>
                      </li>
                      <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                          Bitcoin cannot be efficiently mined with GPUs
                        </span>
                      </li>
                    </ul>

                    <h3>
                      <span style={{ fontWeight: 400 }}>
                        How can I get started with BTC mining?
                      </span>
                    </h3>

                    <ul>
                      <li style={{ fontWeight: 400 }}>
                        <b>Create a wallet address :-</b>
                        <span style={{ fontWeight: 400 }}>
                          You’ll need a wallet address to check and receive
                          payouts to mine Bitcoin with{" "}
                          {brokerBasicInfo?.exchange}. You need to create a BTC
                          wallet address from the More option. Go to
                          More-Generate Mining Address. You will get a BTC
                          address, copy it and save it somewhere. It will work
                          for miner addresses.
                        </span>
                      </li>
                      <li style={{ fontWeight: 400 }}>
                        <b>Mining Configuration:-</b>
                      </li>
                      <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                          You have the BTC wallet address, so you can proceed to
                          configure your mining device. ASIC miners are the
                          easiest mining devices to use compared to GPUs and
                          CPUs, which are no longer profitable for mining
                          bitcoin. No mining software is required to be run on
                          your computer. All you need is the proper electricity
                          setup to meet the power consumption requirements and a
                          reliable internet connection. Please note that your
                          ASICs should have a wired connection to your local
                          network and that your computer and your ASICs should
                          be on the same network. Use any modern browser that
                          accesses the IP address of your machine, then connects
                          to {brokerBasicInfo?.exchange} pool server. You’ll
                          need to enter the following information into your
                          mining device.
                        </span>
                      </li>
                    </ul>

                    <p>
                      <span style={{ fontWeight: 400 }}>
                        <strong>URL</strong>: stratum+tcp://poolpaybito.com:4042
                      </span>
                    </p>
                    <p>
                      <span style={{ fontWeight: 400 }}>
                        <strong>Username</strong>: Your BTC wallet address
                      </span>
                    </p>
                    <p>
                      <span style={{ fontWeight: 400 }}>
                        <strong>Password</strong>: Your choice
                      </span>
                    </p>

                    <ul>
                      <li style={{ fontWeight: 400 }}>
                        <b>Check hashrates:- </b>
                        <span style={{ fontWeight: 400 }}>
                          After the miners are up and running, the performance
                          statistics are expected to be live in approximately 10
                          minutes or more. You need to click more options and
                          put the wallet address and you would get all the
                          details including your balance/rewards.
                        </span>
                      </li>
                    </ul>

                    <p>
                      <span style={{ fontWeight: 400 }}>
                        ASICs take just a few steps to configure. Once you’ve
                        configured your device and saved your settings, you’re
                        ready to start mining and earning rewards.
                      </span>
                    </p>
                  </div>
                )}

                {coinName === "ltc" && (
                  <div className="common-bg-color-opacity border-bt p-4">
                    <h2 style={{ textAlign: "center" }}>
                      <span style={{ fontWeight: 400 }}>
                        How to mine Litecoin in {brokerBasicInfo?.exchange}?
                      </span>
                    </h2>

                    <h3>
                      <span style={{ fontWeight: 400 }}>
                        General Overview: –
                      </span>
                    </h3>

                    <p>
                      <span style={{ fontWeight: 400 }}>
                        Litecoin (LTC) is a cryptocurrency powered by the Scrypt
                        Proof of Work algorithm. LTC aims to provide an
                        alternative to Bitcoin by making modifications to the
                        original Bitcoin Protocol. Litecoin (LTC) was one of the
                        first altcoins created. The Litecoin network was
                        launched on 13 October 2011. LTC is still one of the
                        largest cryptocurrencies by market capitalization since
                        it was first created.
                      </span>
                    </p>

                    <p>
                      <span style={{ fontWeight: 400 }}>
                        Litecoin aims to make it easier for merchants to accept
                        LTC payments by making transactions faster than on the
                        Bitcoin blockchain. Litecoin and Bitcoin do have a few
                        key differences, for example, transactions are faster on
                        Litecoin and it has a larger total supply (84 million
                        LTC). In addition, Litecoin’s halvings were altered as
                        well. Bitcoin halves every 210,000 blocks, while
                        Litecoin halves every 840,000 blocks.
                      </span>
                    </p>

                    <h3>
                      <span style={{ fontWeight: 400 }}>
                        Hardware Requirements:-
                      </span>
                    </h3>

                    <ul>
                      <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                          Litecoin can be efficiently mined with ASIC mining
                          machines.
                        </span>
                      </li>
                      <li style={{ fontWeight: 400 }}>
                        <span style={{ fontWeight: 400 }}>
                          Litecoin cannot be efficiently mined with CPU or GPU
                          card
                        </span>
                      </li>
                      <li style={{ fontWeight: 400 }}>
                        <b>Applicable Miners</b>
                      </li>
                    </ul>

                    <p>
                      <a href="https://shop.bitmain.com/">
                        <span style={{ fontWeight: 400 }}>Antminer</span>
                      </a>
                      <span style={{ fontWeight: 400 }}> (e.g. L5, L3+)</span>
                    </p>

                    <p>
                      <a href="https://www.innosilicon.com/">
                        <span style={{ fontWeight: 400 }}>INNOSILICON </span>
                      </a>
                      <span style={{ fontWeight: 400 }}>(e.g. A6+)</span>
                    </p>

                    <p>
                      <span style={{ fontWeight: 400 }}>
                        Or any miners that support the Scrypt Proof of Work
                        algorithm
                      </span>
                    </p>

                    <h3>
                      <span style={{ fontWeight: 400 }}>
                        How can I get started with LTC mining?
                      </span>
                    </h3>

                    <ul>
                      <li style={{ fontWeight: 400 }}>
                        <b>Create a wallet address :-</b>
                        <span style={{ fontWeight: 400 }}>
                          You’ll need a wallet address to check and receive
                          payouts to mine Litecoin with{" "}
                          {brokerBasicInfo?.exchange}. You need to create a LTC
                          wallet address from the More option. Go to
                          More-Generate Mining Address. You will get a LTC
                          address, copy it and save it somewhere. It will work
                          for miner addresses.
                        </span>
                      </li>
                      <li style={{ fontWeight: 400 }}>
                        <b>Mining Configuration:-</b>{" "}
                        <span style={{ fontWeight: 400 }}>
                          You have the LTC wallet address, so you can proceed to
                          configure your mining device. You’ll need to enter the
                          following information in your mining device:
                        </span>
                      </li>
                    </ul>

                    <p>
                      <span style={{ fontWeight: 400 }}>
                        URL: stratum+tcp://poolpaybito.com:3042
                      </span>
                    </p>
                    <p>
                      <span style={{ fontWeight: 400 }}>
                        Username: Your LTC wallet address
                      </span>
                    </p>
                    <p>
                      <span style={{ fontWeight: 400 }}>
                        Password : Your choice
                      </span>
                    </p>

                    <ul>
                      <li style={{ fontWeight: 400 }}>
                        <b>Check hashrates:-</b>
                        <span style={{ fontWeight: 400 }}>
                          After the miners are up and running, the performance
                          statistics are expected to be live in approximately 10
                          minutes or more. You need to click more options and
                          put the wallet address and you would get all the
                          details including your balance/rewards.
                        </span>
                      </li>
                    </ul>
                  </div>
                )}

                {coinName === "bch" && (
                  <div className="common-bg-color-opacity border-bt p-4">
                    <h2 style={{ textAlign: "center" }}>
                      <b>
                        How to mine Bitcoin Cash in {brokerBasicInfo?.exchange}?
                      </b>
                    </h2>

                    <h4>
                      <b>Overview:-</b>
                    </h4>

                    <p>
                      <span style={{ fontWeight: 400 }}>
                        Like Bitcoin, Bitcoin Cash (BCH) uses the SHA256
                        algorithm, which is supported by BTC rigs such as the
                        Antminer S17, Whatsminer M30, Innosilicon T3T, and
                        Snowpanther A1.
                      </span>
                    </p>

                    <h4>
                      <b>Hardware Requirement:-</b>
                    </h4>
                    <ul>
                      <li style={{ fontWeight: 400 }}>
                        Bitcoin Cash can be efficiently mined with ASIC mining
                        machines.
                      </li>
                      <li style={{ fontWeight: 400 }}>
                        Bitcoin Cash cannot be efficiently mined with CPU or GPU
                        cards.
                      </li>
                    </ul>

                    <h4>
                      <b>How can I get started with BCH mining?</b>
                    </h4>

                    <ul>
                      <li style={{ fontWeight: 400 }}>
                        <b>Create a wallet address :- </b>
                        <span style={{ fontWeight: 400 }}>
                          You’ll need a wallet address to check and receive
                          payouts to mine Litecoin with{" "}
                          {brokerBasicInfo?.exchange}. You need to create a BCH
                          wallet address from the More option. Go to
                          More-Generate Mining Address. You will get a BCH
                          address, copy it and save it somewhere. It will work
                          for miner addresses.
                        </span>
                      </li>

                      <li style={{ fontWeight: 400 }}>
                        <b>Mining Configuration:-</b>
                        <span style={{ fontWeight: 400 }}>
                          You have the BCH wallet address, so you can proceed to
                          configure your mining device. You’ll need to enter the
                          following information in your mining device:
                        </span>
                      </li>
                    </ul>

                    <p>
                      <span style={{ fontWeight: 400 }}>
                        <strong>URL</strong>: stratum+tcp://poolpaybito.com:5042
                      </span>
                    </p>
                    <p>
                      <span style={{ fontWeight: 400 }}>
                        <strong>Username</strong>: Your BCH wallet address
                      </span>
                    </p>
                    <p>
                      <span style={{ fontWeight: 400 }}>
                        <strong>Password</strong>: Your choice
                      </span>
                    </p>

                    <ul>
                      <li style={{ fontWeight: 400 }}>
                        <b>Check hashrates:-</b>
                        <span style={{ fontWeight: 400 }}>
                          After the miners are up and running, the performance
                          statistics are expected to be live in approximately 10
                          minutes or more. You need to click more options and
                          put the wallet address and you would get all the
                          details including your balance/rewards.
                        </span>
                      </li>
                    </ul>
                  </div>
                )}
                {coinName === "doge" && (
                  <div className="common-bg-color-opacity border-bt p-4">
                    <h2 style={{ textAlign: "center" }}>
                      <b>How to mine DOGE in {brokerBasicInfo?.exchange}?</b>
                    </h2>

                    <h3>
                      <b>General Overview:-</b>
                    </h3>

                    <p>
                      <span style={{ fontWeight: 400 }}>
                        DOGE was created as a lighthearted alternative to
                        traditional cryptocurrencies, but it’s become seriously
                        valuable. It is also an open source peer-to-peer
                        cryptocurrency that utilises blockchain technology, a
                        highly secure decentralised system of storing
                        information as a public ledger that is maintained by a
                        network of computers called nodes.
                      </span>
                    </p>

                    <h3>
                      <span style={{ fontWeight: 400 }}>
                        <strong>Hardware Requirement:</strong>–
                      </span>
                    </h3>

                    <p>
                      <span style={{ fontWeight: 400 }}>
                        To mine DOGE, a GPU (Graphics Processing Unit) or an
                        ASIC mining machine is recommended.
                      </span>
                    </p>

                    <h3>
                      <b>How can I get started with DOGE mining?</b>
                    </h3>

                    <ol>
                      <li style={{ fontWeight: 400 }}>
                        <b>Create a wallet address :- </b>
                        <span style={{ fontWeight: 400 }}>
                          You’ll need a wallet address to check and receive
                          payouts to mine DOGE with {brokerBasicInfo?.exchange}.
                          You need to create a DOGE wallet address from the More
                          option. Go to More-Generate Mining Address. You will
                          get a DOGE address, copy it and save it somewhere. It
                          will work for miner addresses.
                        </span>
                      </li>

                      <li style={{ fontWeight: 400 }}>
                        <b>Mining Configuration:-</b>
                        <span style={{ fontWeight: 400 }}>
                          You have the DOGE wallet address, so you can proceed
                          to configure your mining device. You’ll need to enter
                          the following information in your mining device:
                        </span>

                        <p style={{ textAlign: "left" }}>
                          <span style={{ fontWeight: 400 }}>
                            <strong>URL:</strong>{" "}
                            stratum+tcp://poolpaybito.com:6042
                          </span>
                        </p>

                        <p style={{ textAlign: "left" }}>
                          <span style={{ fontWeight: 400 }}>
                            <strong>Username:</strong> Your DOGE wallet address
                          </span>
                        </p>

                        <p style={{ textAlign: "left" }}>
                          <span style={{ fontWeight: 400 }}>
                            <strong>Password:</strong> Your choice
                          </span>
                        </p>
                      </li>

                      <li style={{ fontWeight: 400 }}>
                        <b>Check hashrates:-</b>
                        <span style={{ fontWeight: 400 }}>
                          After the miners are up and running, the performance
                          statistics are expected to be live in approximately 10
                          minutes or more. You need to click more options and
                          put the wallet address and you would get all the
                          details including your balance/rewards.
                        </span>
                      </li>
                    </ol>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CoinMiningInstruction;
